import {Field} from 'formik'
import {useIntl} from 'react-intl'
import {
  CustomSelect
} from '@/components/form'

const initialFilters = {
  status: 'STATUS_ENABLED'
}

const FilterForm = () => {
  const intl = useIntl()
  const statuses = [
    'STATUS_ENABLED',
    'STATUS_DISABLED',
    'STATUS_ARCHIVED'
  ]

  return (
    <>
      <Field
        default="Select status"
        component={CustomSelect}
        label="Status"
        name="status"
        options={statuses.map(s => ({
          value: s,
          label: intl.formatMessage({id: `P2C.SUPPLIER_${s}`})
        }))}
      />
    </>
  )
}

export {FilterForm, initialFilters}
